import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Signup: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [storeName, setStoreName] = useState("");
  const [description, setDescription] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const [fullName, setFullName] = useState("");
  const [country, _setCountry] = useState("US");
  const [address, setAddress] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const navigate = useNavigate();

  
  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    const spaceIndex = fullName.indexOf(" ");
    const firstName = spaceIndex !== -1 ? fullName.slice(0, spaceIndex) : fullName;
    const lastName = spaceIndex !== -1 ? fullName.slice(spaceIndex + 1) : "";

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/users/add`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            first_name: firstName,
            last_name: lastName,
            email,
            password,
            store_name: storeName,
            studio_organization_name: organizationName,
            store_description: description || null,
            country,
            address,
            role_id: 2,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        if(currentRole){navigate("/", { state: { fromSignup: true } });}
        else {navigate("/login", { state: { fromSignup: true } });}
      } else {
        if (data.errors && data.errors.length > 0) {
          setError(data.errors.map((e: { error: string }) => e.error).join(", "));
        } else {
          setError(data.message || "Signup failed. Please try again.");
        }
      }
    } catch (err) {
      setError("Failed to sign up. Please try again." + err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="section-2">
        <div className="div-block-14">
          <div className="div-block-15-copy">
            <p className="subheadline">Everything your team needs, all in one place.</p>
            <h1 className="heading2">Create Your New Account<br /></h1>
            <p className="paragraph-text">Shop dancewear, costumes, shoes, and accessories from one store — built for your group, ready to order.</p>
            <div className="w-form">
              <form id="email-form" className={`form ${isLoading ? "form--loading" : ""}`} onSubmit={handleSignup}>
                <label htmlFor="fullName" className="field-label">Full Name</label>
                <input className="text-field w-input" maxLength={256} name="fullName" type="text" id="fullName" value={fullName} onChange={(e) => setFullName(e.target.value)} required />
                <label htmlFor="email-2" className="field-label">Email*<br /></label>
                <input className="text-field w-input" maxLength={256} name="email-2" placeholder="" type="email" id="email-2" value={email} onChange={(e) => setEmail(e.target.value)} required />
                <label htmlFor="country" className="field-label">Country<br /></label>
                <input className="text-field w-input" name="country" id="country" value="United States" disabled />
                <label htmlFor="address" className="field-label">Address<br /></label>
                <input className="text-field w-input" maxLength={256} name="address" type="text" id="address" value={address} onChange={(e) => setAddress(e.target.value)} required />
                <label htmlFor="storeName" className="field-label">Store Name*</label>
                <input className="text-field w-input" maxLength={256} name="storeName" type="text" id="storeName" value={storeName} onChange={(e) => setStoreName(e.target.value)} required />
                <label htmlFor="description" className="field-label">Description<br /></label>
                <textarea className="text-field w-input" maxLength={255} name="description" id="description" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
                <label htmlFor="organizationName" className="field-label">Studio / Organization Name<br /></label>
                <input className="text-field w-input" maxLength={256} name="organizationName" type="text" id="organizationName" value={organizationName} onChange={(e) => setOrganizationName(e.target.value)} required />
                <label htmlFor="password" className="field-label">Password*<br /></label>
                <input className="text-field w-input" maxLength={256} name="password" type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                <label htmlFor="confirmPassword" className="field-label">Confirm Password*<br /></label>
                <input className="text-field w-input" maxLength={256} name="confirmPassword" type="password" id="currentPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                <button type="submit" className="coa-button-copy w-button" disabled={isLoading}>
                  {isLoading && <span className="spinner" />}
                  Submit
                </button>
                {error && <p className="form-error-msg">{error}</p>}
              </form>
              <div className="w-form-done">
                <div>Thank you! Your submission has been received!</div>
              </div>
              <div className="w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
            <p className="paragraph-text-sm">If you already have a store account, <Link to="/login" className="link-copy">sign in here →</Link><strong><br></br></strong></p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;